<template>
  <EmailComponentsPtPercent />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
